/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFileUpRight: {
  name: 'file-up-right';
  data: string;
} = {
  name: 'file-up-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 4a2 2 0 0 1 2-2h6.586a2 2 0 0 1 .242.015 1.006 1.006 0 0 1 .99.41c.064.05.124.103.182.16L19.414 8c.058.058.112.118.161.182a.999.999 0 0 1 .41.99c.01.08.015.16.015.242V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm2 0h6v4a2 2 0 0 0 2 2h4v10H6V4Zm8 1.414L16.586 8H14V5.414ZM10 16a1 1 0 1 1 0-2h1.586l-.293-.293a1 1 0 0 1 1.414-1.414l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414-1.414l.293-.293H10Z" fill="currentColor"/></svg>`,
};
